export const DEFAULT_GOOGLE_MERCHANT_SETTINGS = {
  enabled: false,
  accountId: '',
  dataSourceId: '10709701387',
  serviceAccountEmail: '',
  serviceAccountSet: false,
  lastSyncAt: null,
  lastSyncError: '',
  lastSyncStats: null,
  ready: false
};

export const normalizeGoogleMerchantSettings = (raw = {}) => ({
  enabled: raw.enabled === true,
  accountId: String(raw.accountId || '').replace(/\D/g, ''),
  dataSourceId: String(raw.dataSourceId || DEFAULT_GOOGLE_MERCHANT_SETTINGS.dataSourceId).replace(/\D/g, '')
    || DEFAULT_GOOGLE_MERCHANT_SETTINGS.dataSourceId,
  serviceAccountEmail: String(raw.serviceAccountEmail || '').trim(),
  serviceAccountSet: raw.serviceAccountSet === true,
  lastSyncAt: raw.lastSyncAt || null,
  lastSyncError: String(raw.lastSyncError || ''),
  lastSyncStats: raw.lastSyncStats || null,
  ready: raw.ready === true
});
